<template>
	<div class="">
		<div class="content" ref="main"></div>
	</div>
</template>

<script>

	export default {
		name: "",
		components: {
			
		},
		data() {
			return {
				main:null,
				option : {
					xAxis: {
						type: 'category',
						data: ['经济与金融', '金融学', '计算机', '数字媒体', '运营与技术', '化工化学', '其他'],
						axisTick:{
							show:false,
						},
						axisLine:{
							show:true,
							lineStyle:{
								color:"#29A7E1"
							}
						},
						axisLabel:{
							color:"#666666",
							hideOverlap:false,
							showMinLabel:true
						},
					},
					yAxis: {
						data: [300, 1000, 3000, 5000, 20000, 30000, 50000],
						type: 'value',
						min:300,
						max:50000,
				
						name:"人数",
						nameTextStyle:{
							align:"right",
							color:"#333333",
						},
						axisLabel:{
							color:"#666666",
						},
						axisLine:{
							show:true,
							lineStyle:{
								color:"#29A7E1"
							}
						},
						splitLine:{
							show:true,
							lineStyle:{
								type:"dashed",
								color:"#666666",
								width:0.5,
							}
						}
					},
					series: [
						{
							data: [8500, 25000, 12500, 25000, 12500, 25000, 8500],
							type: 'bar',
							name:"Forest",
							showBackground: false,
							itemStyle: {
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
										{ offset: 0, color: '#29A7E1' },
										{ offset: 1, color: '#ffffff00' }
									]),
								borderRadius: [5, 5, 0, 0]
							},
							label: {
								show: true,
								position: 'top',
								color:"#29A7E1"
							},
						},
						{
							data: [2500, 12500, 2500, 12500, 2500, 12500, 12500],
							type: 'bar',
							showBackground: false,
							itemStyle: {
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
										{ offset: 0, color: '#FE9603' },
										{ offset: 1, color: '#ffffff00' }
									]),
								borderRadius: [5, 5, 0, 0]
							},
							label: {
								show: true,
								position: 'top',
								color:"#FE9603",
								formatter:function(item){
									return parseInt(item.value / 50000 * 100) + "%"
								}
							},
						}
					]
				}
			}
		},
		mounted(){
			this.main = this.$echarts.init(this.$refs.main);
			this.main.setOption(this.option);
			 window.onresize = () => {
				this.main.resize();
			};
		},
		methods: {
			
		}


	}
</script>

<style scoped>
	.content{width: 100%;height: 421px;}
	@media (min-width: 768px) {
		.content{width: 100%;height: 421px;}
	}
	@media (min-width: 992px) {
		.content{width: 100%;height: 421px;}
	}
	
	@media (min-width: 1200px) {
		.content{width: 100%;height: 421px;}
	}
	
</style>



// WEBPACK FOOTER //
// src/views/tubiao/wodexuanke.vue